import { apiProvider, apiClient } from './utilities/Provider';

const getAll = ({ search = '', page = 1, pageSize = 100 } = {}) => {
    const query = new URLSearchParams();
    if (search) query.set('search', search);
    query.set('page', String(page));
    query.set('pageSize', String(pageSize));
    return apiProvider.get(`users?${query.toString()}`);
};

const create = ({ email, firstName, lastName, role }) =>
    apiProvider.post('users', { email, firstName, lastName, role });

const update = (id, { firstName, lastName, role, isActive }) =>
    apiProvider.put(`users/${id}`, { firstName, lastName, role, isActive });

const deactivate = (id) => apiProvider.remove('users', id);

const resendActivation = (id) =>
    apiProvider.post(`users/${id}/resend-activation`, {});

// apiClient so errors reject.
const resetTwoFactor = (id) =>
    apiClient.post(`/users/${id}/reset-two-factor`, {});

const UserService = { getAll, create, update, deactivate, resendActivation, resetTwoFactor };

export default UserService;
